import { Ref } from "@tblabs/truffle";
import { BasketItem } from "./BasketItem";
import { BasketItemType } from "./BasketItemType";
import { RawRentBasketItem } from "./RawRentBasketItem";
import { TimeUtils } from "../../Utils/TimeUtils";
import { RawBasketItem } from "./RawBasketItem";
import { OrderProductOption } from "./ProductOption";
import { ProductInfo } from "./Product";


export class RentBasketItem extends BasketItem
{
    public Type = BasketItemType.Rent;
    public From = new Ref<Date>(new Date(0));
    public To = new Ref<Date>(new Date(0));
    public Deposit = new Ref<number>(0);

    constructor(raw: Partial<RawRentBasketItem>)
    {
        super(raw);

        this.From.value = new Date(raw.From || 0);
        this.To.value = new Date(raw.To || 0);
        this.Deposit.value = raw.Deposit || 0;
    }

    public get AsString(): string
    {
        return `Wypożyczenie: ${this.ProductInfo.Name} (${this.Option.Name || "opcja domyślna"}) x${this.Quantity.value}, ${TimeUtils.FormattedRange(this.From, this.To)}`;
    }

    public get AsRaw(): RawBasketItem
    {
        return ({
            ...super.AsRaw,
            From: this.From.value,
            To: this.To.value,
            Deposit: this.Deposit.value,
        } as RawRentBasketItem);
    }
}
